import { render, staticRenderFns } from "./AdditionalSubjectsDropDown.vue?vue&type=template&id=feeb980c&scoped=true&"
import script from "./AdditionalSubjectsDropDown.vue?vue&type=script&lang=js&"
export * from "./AdditionalSubjectsDropDown.vue?vue&type=script&lang=js&"
import style0 from "./AdditionalSubjectsDropDown.vue?vue&type=style&index=0&id=feeb980c&prod&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "feeb980c",
  null
  
)

export default component.exports